export default __webpack_public_path__ + "static/media/TL11.924ce328.mp3";